"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepsList = exports.StepBar = exports.Progress = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StepBar = exports.StepBar = _styledComponents["default"].div.withConfig({
  displayName: "DefaultStepBarstyle__StepBar",
  componentId: "sc-1bz1nbi-0"
})({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
});
var StepsList = exports.StepsList = _styledComponents["default"].ul.withConfig({
  displayName: "DefaultStepBarstyle__StepsList",
  componentId: "sc-1bz1nbi-1"
})({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  listStyleType: 'none',
  margin: 0,
  padding: 0
});
var Progress = exports.Progress = _styledComponents["default"].div.withConfig({
  displayName: "DefaultStepBarstyle__Progress",
  componentId: "sc-1bz1nbi-2"
})(function (_ref) {
  var spacing = _ref.theme.spacing;
  return {
    width: '100%',
    marginTop: spacing.inline['3xs']
  };
});